module.exports = __webpack_public_path__ + "img/IMG_2061.17e33628.jpg";